function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.18,319.55,152.61,368.62,114.77,171.44l-2.15-11.22,137.7-66.63a5.14,5.14,0,0,1,7,3.46l2.85,11.14L311.9,310.78A7.17,7.17,0,0,1,307.18,319.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.91,201.67s-7.84,14.32-7.76,17.56,15,25.72,15.4,28.27,11.19,7.47,15.13,10.08,8.92-16.31,8.27-29.93S288.91,201.67,288.91,201.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,279.33a108.7,108.7,0,0,1,5.79-64.5c11.55-28.56,36.37-48.85,64.17-60.69,40.41-17.2,80.08-17.53,112.92-51.25,10.13-10.4,18.63-22.31,29-32.49,30.52-30,75.19-26.4,108.55-2.58,69.58,49.69,94.61,148.11,90.74,229.47-1.73,36.51-19.17,70.49-46.76,94.45-62.4,54.18-168.35,45.07-240,16.78C112.05,387.43,53.68,338.23,41.13,279.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,279.33a108.7,108.7,0,0,1,5.79-64.5c11.55-28.56,36.37-48.85,64.17-60.69,40.41-17.2,80.08-17.53,112.92-51.25,10.13-10.4,18.63-22.31,29-32.49,30.52-30,75.19-26.4,108.55-2.58,69.58,49.69,94.61,148.11,90.74,229.47-1.73,36.51-19.17,70.49-46.76,94.45-62.4,54.18-168.35,45.07-240,16.78C112.05,387.43,53.68,338.23,41.13,279.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-252"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 358.58,
    y1: 105.45,
    x2: 355.08,
    y2: 105.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.09,
    y1: 105.45,
    x2: 127.9,
    y2: 105.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeDasharray: "6.990300178527832,6.990300178527832"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.4,
    y1: 105.45,
    x2: 120.9,
    y2: 105.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361,
    y1: 390.34,
    x2: 361,
    y2: 386.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361,
    y1: 379.78,
    x2: 361,
    y2: 114.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeDasharray: "7.063330173492432,7.063330173492432"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361,
    y1: 111.37,
    x2: 361,
    y2: 107.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.58,
    y: 103.03,
    width: 4.84,
    height: 4.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-252"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.5 119.94 366.3 105.15 381.09 140.36 385.17 128.45 393.03 136.31 397.45 131.89 389.59 124.03 401.5 119.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.65,430.21H298.91a5.42,5.42,0,0,1-5.16-4.44l-3.87-24.26a3.69,3.69,0,0,1,3.74-4.44h34.75a5.42,5.42,0,0,1,5.16,4.44l3.87,24.26A3.7,3.7,0,0,1,333.65,430.21Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,430.21a4.46,4.46,0,0,0,4.45-4.46V398.4A4.44,4.44,0,0,0,334,394l-1.08-2.78a1.37,1.37,0,0,0-1.27-.86H320.26a1.35,1.35,0,0,0-1.26.86L317.93,394h-19a4.47,4.47,0,0,0-4.22,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,430.21H168.24a5.42,5.42,0,0,1-5.16-4.44l-3.87-24.26a3.7,3.7,0,0,1,3.75-4.44H197.7a5.41,5.41,0,0,1,5.16,4.44l3.87,24.26A3.7,3.7,0,0,1,203,430.21Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,430.21a4.46,4.46,0,0,0,4.46-4.46V398.4A4.44,4.44,0,0,0,203.3,394l-1.08-2.78a1.35,1.35,0,0,0-1.26-.86H189.6a1.37,1.37,0,0,0-1.27.86L187.26,394h-19a4.47,4.47,0,0,0-4.22,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,430.21H233.58a5.42,5.42,0,0,1-5.16-4.44l-3.87-24.26a3.69,3.69,0,0,1,3.74-4.44H263a5.41,5.41,0,0,1,5.16,4.44l3.87,24.26A3.69,3.69,0,0,1,268.32,430.21Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,430.21a4.46,4.46,0,0,0,4.45-4.46V398.4a4.44,4.44,0,0,0-4.13-4.42l-1.09-2.78a1.35,1.35,0,0,0-1.26-.86H254.93a1.35,1.35,0,0,0-1.26.86L252.6,394h-19a4.46,4.46,0,0,0-4.22,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.42,159.54l9.42-11.63a11.29,11.29,0,0,0,2.26-9.48L290.17,97a6.91,6.91,0,0,0-6.76-5.45H266.1a11.17,11.17,0,0,0-3.62.6L95,160.7l42.44,220.39c6,9,173.4-48.91,173.4-48.91a11.27,11.27,0,0,0,7.39-13.29L284,174.65A17.58,17.58,0,0,1,287.42,159.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.93,96.42l53,227.18s-179.23,66.76-170.79,46.1c0,0-42.65-202.95-39.05-203.7S262.93,96.42,262.93,96.42Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.18,319.55,152.61,368.62,114.77,171.44l-2.15-11.22,137.7-66.63a5.14,5.14,0,0,1,7,3.46l2.85,11.14L311.9,310.78A7.17,7.17,0,0,1,307.18,319.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-252)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.21,108.19,115.88,174.25l-3.26-14,137.7-66.63a5.14,5.14,0,0,1,7,3.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,103.3a3.18,3.18,0,0,1-3.19,3.43,3.76,3.76,0,0,1-3.2-3.88,3.17,3.17,0,0,1,3.2-3.43A3.76,3.76,0,0,1,253,103.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.73,107.38a3,3,0,0,1-3,3.18,3.48,3.48,0,0,1-3-3.6,3,3,0,0,1,3-3.18A3.49,3.49,0,0,1,244.73,107.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94,110.91a2.75,2.75,0,0,1-2.78,3,3.25,3.25,0,0,1-2.77-3.36,2.76,2.76,0,0,1,2.77-3A3.26,3.26,0,0,1,236.94,110.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.18,319.55,152.61,368.62,114.77,171.44l-2.15-11.22,137.7-66.63a5.14,5.14,0,0,1,7,3.46l2.85,11.14L311.9,310.78A7.17,7.17,0,0,1,307.18,319.55Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307.18,319.55,152.61,368.62,114.77,171.44l-2.15-11.22,137.7-66.63a5.14,5.14,0,0,1,7,3.46l2.85,11.14L311.9,310.78A7.17,7.17,0,0,1,307.18,319.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,309.83,145.55,369.7,108.22,175.16,106.1,164.1,241.94,87.85a4.76,4.76,0,0,1,6.95,3l2.8,10.94,51,199A7.73,7.73,0,0,1,298,309.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.69,101.75,109.31,177.9l-3.21-13.8L241.94,87.85a4.76,4.76,0,0,1,6.95,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,97.37a3.19,3.19,0,1,1-3.15-3.65A3.43,3.43,0,0,1,244.56,97.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.42,102a3,3,0,1,1-2.92-3.38A3.18,3.18,0,0,1,236.42,102Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,106.1a2.77,2.77,0,1,1-2.74-3.17A3,3,0,0,1,228.74,106.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08,106.67,295,282.48a1.53,1.53,0,0,1-.86,1.77l-4.1,1.81a1.5,1.5,0,0,1-2.06-1l-43.7-174.8a2.06,2.06,0,0,1,1-2.3l3.38-1.9A1,1,0,0,1,250.08,106.67Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.23,111.75l2.48-1.37a1.77,1.77,0,0,1,2.57,1.12l4.59,18.42a2.08,2.08,0,0,1-1,2.33l-3,1.6A1.28,1.28,0,0,1,250,133l-4.74-19A2.06,2.06,0,0,1,246.23,111.75Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.65,
    y1: 308.59,
    x2: 170.43,
    y2: 349.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.93,
    y1: 296.26,
    x2: 157.16,
    y2: 349.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.67 243.19 259.6 200.37 232.32 213.41 242.29 256.08 269.67 243.19",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.19 165.84 230.67 206.38 257.92 193.19 248.15 151.65 221.19 165.84",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.29 147.98 239.31 114.03 212.38 128.14 220.36 162.27 247.29 147.98",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.28 260.31 252.46 299.57 280.08 287.47 270.8 248 243.28 260.31",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,160.7l42.44,220.39c13.59-15.51,110.62-86.58,110.62-86.58a23.31,23.31,0,0,0,9.05-24L212.18,77.85A9.89,9.89,0,0,0,196,72.64S105.74,129.33,95,160.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.42,277.37a2.84,2.84,0,0,1-2.76-2.18q-1.16-4.72-2.26-9.46a2.85,2.85,0,1,1,5.54-1.3c.74,3.15,1.48,6.29,2.24,9.42a2.84,2.84,0,0,1-2.09,3.44A3.07,3.07,0,0,1,249.42,277.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.61,252.05a2.84,2.84,0,0,1-2.77-2.21L201.91,78.94a.32.32,0,0,0-.21-.25.33.33,0,0,0-.32,0c-10,6.66-43.81,29.34-59.49,41.88-10,8.31-19.13,17.87-29.63,30.93a2.84,2.84,0,0,1-4.43-3.56c10.74-13.38,20.14-23.18,30.47-31.78,15.46-12.37,47.06-33.63,59.93-42.2a6,6,0,0,1,9.23,3.69l38.93,170.89a2.85,2.85,0,0,1-2.15,3.41A2.7,2.7,0,0,1,243.61,252.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.19,462.39c-1.34-12.08-3.15-28.86-4.72-44.85-2.28-23.35-4.06-45-3.1-47.69a27,27,0,0,0,1.76-10.69c4.76-.52,6.89-7,6.89-7l-2.56-22.81s1.59-43.69-.36-56.09-9.93-20.73-10.09-24,6.21-17.82,8.3-22,.89-27.54-2.49-34.85a7.6,7.6,0,0,0-3.82-4c-3.56-1.59-7.62.19-7.62.19A65.25,65.25,0,0,1,103.66,218h0c-3.28,5.7-6.31,9.38-6.86,12.39-1.17,6.44-15.38,23.06-18.07,31.66S75.18,299.87,71,311.39c-2,5.42-9.13,22.7-11,75.39a450.83,450.83,0,0,1-9.55,75.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.31,227.23c-2.09,4.15-8.46,18.67-8.3,22s8.12,11.62,10.09,24,.36,56.09.36,56.09L131,352.14s-2.13,6.5-6.89,7a27,27,0,0,1-1.76,10.69c-1,2.73.82,24.34,3.1,47.69-2.38-10.08-4.34-17.86-4.34-17.86s-1,12.4-2.39,22.19-4.58,23.71-4.58,23.71-7.15-67.39-5.49-78.65,5.76-9.41,2.59-14.8S88.86,342.08,90.74,338s16.91,3.15,17.54,3.44c-.51-.41-8.87-7.1-8.8-10.2s13.41,5,13.41,5a45.62,45.62,0,0,0,9.64-8c4.07-4.68-2-49.45-3.12-52.68s-8.29-2.77-10.38-5.46,3.59-3.89,2.5-8-4-3.74-4-3.74,4.69-6.87,4.27-12.86,7.36-13.21,6.8-17.53c-2.18-16.82-12.2-5.23-14.92-10h0a65.25,65.25,0,0,0,8.72-29.37s4.06-1.78,7.62-.19a7.6,7.6,0,0,1,3.82,4C127.2,199.69,128.41,223.07,126.31,227.23Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65,445.58a439,439,0,0,0,6.3-58.8c1.89-52.69,9-70,11-75.39,4.21-11.51,5.09-40.76,7.77-49.36s16.9-25.22,18.06-31.66,13.84-16.07,15.58-41.77c0,0,8.05-3.53,11.44,3.78s4.59,30.69,2.49,34.85-8.47,18.67-8.3,22,8.12,11.62,10.08,24,.37,56.1.37,56.1L131,352.14s-2.12,6.5-6.88,7a27,27,0,0,1-1.75,10.68c-1.51,4.24,3.58,53.81,7,84.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,249.2s-2.51,7-7.38,7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,252.33s1.48,8.5-3.77,13.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,226.19s5.9-1.16,9.6,1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,339.48s19.17,6,22.2,9.07,7.44,10.61,7.44,10.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.46,336.53c2.82,3.17,9.12,6.79,12.1,9.6s4.47,9.09,4.47,9.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05,335.05s4.43-2.19,6.71-9.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88,360.59c-4.2,2.12-4.31,26.2-2.1,53.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08,365.58c0,2.66,3.61,23,5.26,40.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.91,201.67s-7.84,14.32-7.76,17.56,15,25.72,15.4,28.27,11.19,7.47,15.13,10.08,8.92-16.31,8.27-29.93S288.91,201.67,288.91,201.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-252)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.91,201.67s-7.84,14.32-7.76,17.56,15,25.72,15.4,28.27,11.19,7.47,15.13,10.08,8.92-16.31,8.27-29.93S288.91,201.67,288.91,201.67Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,201.67s-7.84,14.32-7.76,17.56,15,25.72,15.4,28.27,11.19,7.47,15.13,10.08,8.92-16.31,8.27-29.93S288.91,201.67,288.91,201.67Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.27,228.28s7.7-3.5,16.08,5.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.15,361.45l-47,53.08s-7.73-9.63-17.4-21.4c-13.75-16.71-31.41-37.74-36.41-41.57-6.1-4.69-45.75-31.8-56.71-45.23-1.57-1.93-2.94-3.63-4.15-5.19h0c-7.23-9.32-8.67-13.32-12.26-26.32-4.19-15.2-8.81-23.59-10-29.21,0-.17-.07-.34-.1-.53-1.21-6.23-3.33-25-6.09-29.77-2.84-4.92,8.44-7.3,12.74-4.56s15,16,14.35,27.48c0,0,8.43,20.77,12.73,20.21,0,0-.56-20.81-3.42-25.89a16.85,16.85,0,0,1-2.2-7.6,10,10,0,0,1,.06-1.93s-13.25-14.3-17.15-23.93-11.54-24.45-13-38.87c0,0-1.72-10.37,4.57-15.07,2.39-1.79,4.6-2.3,6.83.8a23.91,23.91,0,0,1,2.79,5.85c9.41,26.56,21,36.74,21,36.74a89.74,89.74,0,0,1,13.29,4.6,21.92,21.92,0,0,1,2.72,1.61h0c2.47,1.66,5.47,4.06,8.57,6.42,4.46,3.39,9.11,6.67,12.6,7.44,12.17,2.64,18,8.82,18,8.82s8.08-1.72,12.35,5.8c4.15,7.28,6.43,8.73,6.43,8.73s3.05,0,5.5,5.38c4.32,9.44,17.3,59.72,17.94,61.75,5.22,16.63,20.74,34.48,38.5,50.12h0C443.14,353.49,448.14,357.58,453.15,361.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.39,194.76h0Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.47,215.14s-14.06-2.53-16.83-8.91-14.54-20-17.36-20.88a4.44,4.44,0,0,0-4.57,1.08s-4.88-7.7-8.55-14.35c-3.48-6.32-20.7-25.27-5.63-26.13a23.91,23.91,0,0,1,2.79,5.85c9.41,26.56,21,36.74,21,36.74a89.74,89.74,0,0,1,13.29,4.6,21.92,21.92,0,0,1,2.72,1.61c-.36-.09-6-1.49-4.87,1.39s10.3,11.28,15.12,14.92S331.47,215.14,331.47,215.14Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.3,349.22c-7.95-4.35-20-11.54-24-17.19-6.18-8.7-10.77-13.06-14.89-18.1s-11.92-9.16-10.09-8.48S399.43,309,399.43,309a79.87,79.87,0,0,1-11-20.49c-4.81-12.83-13.57-58-20.08-63s0,44.28,0,44.28a146.21,146.21,0,0,1-9.25-30c-3-16.2-5.7-24.15-9.22-26.34s-10.26,2.42-12.1,0,.24-3.31-10.82-12.25c4.46,3.39,9.11,6.67,12.6,7.44,12.17,2.64,18,8.82,18,8.82s8.08-1.72,12.35,5.8c4.15,7.28,6.43,8.73,6.43,8.73s3.05,0,5.5,5.38c4.32,9.44,17.3,59.72,17.94,61.75C405,315.73,420.54,333.58,438.3,349.22Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,268c-.52,3-4.3-5.86-4.64-4.49s-1.37,5.89-1.43,4.49-8.08-5.86-9.46-12.51-2.29-9.48-3-11.15-1.91,1.11-2-2.92c-.07-3.61-11.69-7.41-17.88,3.66-1.21-6.23-3.33-25-6.09-29.77-2.84-4.92,8.44-7.3,12.74-4.56s15,16,14.35,27.48c0,0,8.43,20.77,12.73,20.21,0,0-.56-20.81-3.42-25.89a16.85,16.85,0,0,1-2.2-7.6l4.19.57c1.13,2.48-1.08,6,0,7.8s7.86,14.82,5.61,21.57S308,265,307.48,268Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,393.13c-13.75-16.71-31.41-37.74-36.41-41.57-6.1-4.69-45.75-31.8-56.71-45.23-1.57-1.93-2.94-3.63-4.15-5.19,5.84,7.13,13,10.88,16.08,12.56,5.5,3,21.43,5.54,32.55,17.6,5.4,5.86,8.48,10.13,15.12,17.46s16.27,7.79,22,17.88C380.07,371.7,384.84,383.09,388.72,393.13Z",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,414.53s-45.3-56.44-53.81-63c-6.1-4.68-45.75-31.8-56.71-45.23S283.38,290,279.19,274.81s-8.8-23.58-10-29.21-3.35-25.38-6.19-30.29,8.44-7.3,12.74-4.57,15,16,14.35,27.49c0,0,8.43,20.77,12.73,20.21,0,0-.56-20.81-3.42-25.89a15.85,15.85,0,0,1-2.13-9.52S284,208.72,280.13,199.09s-11.54-24.45-13-38.87c0,0-1.71-10.36,4.58-15.07,3.38-2.53,6.38-2.5,9.62,6.65,9.42,26.56,21,36.74,21,36.74a89.74,89.74,0,0,1,13.29,4.6c5.6,2.63,17,14,23.92,15.47,12.16,2.65,18,8.83,18,8.83s8.08-1.72,12.35,5.8c4.14,7.28,6.43,8.74,6.43,8.74s3,0,5.5,5.37c4.32,9.44,17.3,59.72,17.94,61.75,6.65,21.17,30,44.31,53.35,62.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,188.54s11.51,15.94,19.57,19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3,211.06c7.76,2.49,12.77,4,14.2,9.82s5.58,19.08,7.58,24.28,6.8,18.35,6.8,18.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,258.44s5.28,6.87,4,13.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,257.33s-.23,7.47,1.64,12.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29,223s4.24,2.28,5.25,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,235.06a30.57,30.57,0,0,0,3.94,6.36c2.05,2.25,3,9.56,3,9.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,245.6s4.57-5.14,9.29-5.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.84,187.53s5.32-4,9.35-1.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.34,244.93c1.06,2.91,6.5,29.19,7.86,32.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14,214.81s5-3.58,11.26.81,6.27,6.51,10.13,5.48a6.5,6.5,0,0,1,6.4,2.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,233.32c1,5.89,5.24,34.72,7.29,42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFound);
export default __webpack_public_path__ + "static/media/found.d51df516f750f2ca4d4502e12b5c1efc.svg";
export { ForwardRef as ReactComponent };